import { fg } from '@atlaskit/platform-feature-flags/fg';
import { IdentityUserAri } from '@atlassian/ari';

/** Keeps the identity probe and full profile query on the same account ID. */
export function profileQueryAccountId(userId: string): string {
	return IdentityUserAri.check(userId) && fg('ptc_user_profile_card_normalize_user_ari')
		? IdentityUserAri.parse(userId).userId
		: userId;
}
